<template>
	<div>
		<a-page-header style="background: #fff;" title="商品管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'商品管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addGoodsModal = true">
					添加商品
				</a-button>
			</template>
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input style="width: 300px" placeholder="请输入商品名称" v-model="searchForm.word" />
				</a-form-model-item>
				<a-form-model-item>
					<a-cascader :options="goodsClassList" placeholder="商品分类" v-model="searchForm.goodsClass" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="goodsThumb" slot-scope="goodsThumb">
						<a-avatar shape="square" :src="goodsThumb" :size="70" />
					</span>
					<span slot="goodsDelivery" slot-scope="goodsDelivery">
						<a-tag color="green" v-if="goodsDelivery == 1">现货</a-tag>
						<a-tag color="blue" v-if="goodsDelivery == 2">隔日到</a-tag>
					</span>
					<span slot="goodsClass" slot-scope="goodsClass">
						<a-tag color="blue" v-if="goodsClass">{{goodsClass}}</a-tag>
					</span>
					<span slot="goodsInventory" slot-scope="text,goodsInventory">
						{{goodsInventory.goodsInventory}} {{goodsInventory.goodsUnit}}
					</span>
					<span slot="goodsPrice" slot-scope="text,goodsPrice">
						<template v-if="goodsPrice.isSpecs == 1">
							<span style="font-weight: 700;margin-right: 20px;font-size: 20px;">{{goodsPrice.goodsPrice}} 元</span> 
							<span style="text-decoration:line-through;color: #8c8c8c;margin-right: 18px;">{{goodsPrice.goodsOldPrice}} 元</span> 
							<span style="margin-right: 20px;">库存 {{goodsPrice.goodsInventory}} {{goodsPrice.goodsUnit}}</span> 
							<!-- <span style="">送积分 {{goodsPrice.goodsIntegral}}</span> -->
						</template>
						<template v-if="goodsPrice.isSpecs == 2">
							<div v-for="(item,index) in goodsPrice.goodsPrice" :key="index">
								<a-tag color="blue">{{item.goodsSpecsName}}</a-tag>
								<span style="font-weight: 700;margin-right: 20px;font-size: 20px;">{{item.goodsPrice}} 元</span>
								<span style="text-decoration:line-through;color: #8c8c8c;margin-right: 18px;">{{item.goodsOldPrice}} 元</span> 
								<span style="margin-right: 20px;">库存 {{item.goodsInventory}} {{goodsPrice.goodsUnit}}</span> 
								<!-- <span style="">送积分 {{item.goodsIntegral}}</span> -->
							</div>
						</template>
					</span>
					<span slot="goodsStatus" slot-scope="goodsStatus">
						<a-tag v-if="goodsStatus == true" color="green">已上架</a-tag>
						<a-tag v-if="goodsStatus == false" color="orange">已下架</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加商品 -->
		<a-modal title="添加商品" v-model="addGoodsModal" @ok="addGoodsSubmit" cancelText="取消" okText="下一步" width="50%">
			<a-form-model ref="addGoodsForm" :model="addGoodsForm" :rules="addGoodsFormRules" :label-col="{ span: 8 }"
			 :wrapper-col="{ span: 10 }">
				<a-form-model-item label="商品名称" prop="goodsName">
					<a-input v-model="addGoodsForm.goodsName" placeholder="请输入商品名称" />
				</a-form-model-item>
				<a-form-model-item label="商品分类" prop="goodsClass">
					<a-cascader :options="goodsClassList" placeholder="请选择商品类型" v-model="addGoodsForm.goodsClass" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '商品分类',
			dataIndex: 'goodsClass',
			scopedSlots: {
				customRender: 'goodsClass'
			},
		},
		{
			title: '商品名称',
			dataIndex: 'goodsName',
			scopedSlots: {
				customRender: 'goodsName'
			},
		},
		{
			title: '缩略图',
			dataIndex: 'goodsThumb',
			scopedSlots: {
				customRender: 'goodsThumb'
			},
		},
		{
			title: '送达时间',
			dataIndex: 'goodsDelivery',
			scopedSlots: {
				customRender: 'goodsDelivery'
			},
		},
		{
			title: '售价',
			dataIndex: 'goodsPrice',
			scopedSlots: {
				customRender: 'goodsPrice'
			},
		},
		{
			title: '销量',
			dataIndex: 'goodsSales',
			scopedSlots: {
				customRender: 'goodsSales'
			},
		},
		{
			title: '排序',
			dataIndex: 'sort',
			scopedSlots: {
				customRender: 'sort'
			},
		},
		{
			title: '状态',
			dataIndex: 'goodsStatus',
			scopedSlots: {
				customRender: 'goodsStatus'
			},
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				goodsClassList: [],
				searchForm: {},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				loading: false,
				addGoodsModal: false,
				addGoodsForm: {},
				addGoodsFormRules: {
					goodsName: [{
						required: true,
						message: '请填写商品名称',
						trigger: 'blur'
					}],
					goodsClass: [{
						required: true,
						message: '请选择商品分类',
						trigger: 'change'
					}]
				},
			};
		},

		mounted() {
			this.getList()
			this.getGoodsClassList()
		},

		methods: {

			addGoodsSubmit() {
				this.$http.post('/admin/index.php/admin/Shop/goodsSave', {
					goodsName: this.addGoodsForm.goodsName,
					goodsClass: JSON.stringify(this.addGoodsForm.goodsClass)
				}).then((res) => {
					if (res.data.code == 1) {
						this.$router.push('/goods/goodsDetail?id=' + res.data.data)
					} else {
						this.$message.error(res.data.msg);
					}
				})

			},

			toDetail(id) {
				this.$router.push('/goods/goodsDetail?id=' + id)
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Shop/goodsDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					word: this.searchForm.word,
					goodsClass: JSON.stringify(this.searchForm.goodsClass)
				}
				this.$http.post('/admin/index.php/admin/Shop/goodsList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getGoodsClassList() {
				this.$http.get('/admin/index.php/admin/Shop/classPullList').then(res => {
					if (res.data.code == 1) {
						this.goodsClassList = res.data.data
					}
				})
			}
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
